import Button from '@components/_Layout/Controls/Button';
import InputLabel from '@components/_Layout/Controls/InputLabel';
import InputText from '@components/_Layout/Controls/InputText';
import Popup from '@components/_Layout/Controls/Popup';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Select from '@components/_Layout/Controls/Select';
import SelectCountry from '@components/_Layout/Controls/SelectCountry';
import { BankAccountDetailsType } from '../../../types';
import { SelectOptionType } from '../../../types';
import { useSession } from '@hooks';

type BankAccountsAreaProps = {
  //
};

const languagesVarsCodes = [
  "LANG_neobooking_bankaccount_account", //Comptes bancaires
  "LANG_neobooking_bankaccount_account_validate", //Comptes validés
  "LANG_neobooking_bankaccount_label", //Libelle
  "LANG_neobooking_bankaccount_infos", //Infos
  "LANG_neobooking_bankaccount_action", //Action
  "LANG_neobooking_bankaccount_details", //Détails
  "LANG_neobooking_bankaccount_details_account", //Détails sur le compte bancaire
  "LANG_neobooking_bankaccount_media_label", //Libellé du média
  "LANG_neobooking_bankaccount_validate", //Validé
  "LANG_neobooking_bankaccount_type", //Type
  "LANG_neobooking_bankaccount_bank_code", //Code banque
  "LANG_neobooking_bankaccount_agency_code", //Code agence
  "LANG_neobooking_bankaccount_account_number", //Numéro de compte
  "LANG_neobooking_bankaccount_key", //Clé
  "LANG_neobooking_bankaccount_iban", //IBAN
  "LANG_neobooking_bankaccount_bic", //BIC
  "LANG_neobooking_bankaccount_address", //Adresse banque
  "LANG_neobooking_bankaccount_address_2", //Suite adresse banque
  "LANG_neobooking_adr_zipcode", //Code postal
  "LANG_neobooking_city", //Ville
  "LANG_neobooking_country", //Pays
  "LANG_neobooking_bankaccount_impossible_to_remove", //Impossible de supprimer un compte bancaire utilisé
  "LANG_neobooking_bankaccount_save", //Enregistrer
]

const BankAccountsArea: React.FC<BankAccountsAreaProps> = () => {

  /* Hooks */
  const { getLanguageVarValue } = useSession();

  const bankAccount: BankAccountDetailsType[] = [
    {
      media_label: "Crédit Agricole",
      validated: true,
      type: "RIB",
      ribBankCode: "18206",
      ribBankAgency: "00210",
      ribAccountNumber: "54872667002",
      ribKey: "17",
      bankAddress: "",
      bankAddress2: "",
      postalCode: "",
      city: "",
      country: ""
    },
    {
      media_label: "Tom Desavoie",
      validated: true,
      type: "IBAN",
      bicCode: "BICCODE123",
      iban: "02455125848",
      bankAddress: "40 Impasse des Vaches",
      bankAddress2: "",
      postalCode: "06560",
      city: "Valbonne",
      country: "France"
    }
  ]

  const bankType: SelectOptionType[] = [
    {
      value: "RIB",
      label: "RIB",
    },
    {
      value: "IBAN",
      label: "IBAN",
    }
  ]

  const [selectedType, setSelectedType] = useState<string>(bankType[0].value)
  const [selectedCountry, setSelectedCountry] = useState<string>("IT")

  return <div>
    <span className="tw-block tw-font-bold">{getLanguageVarValue("LANG_neobooking_bankaccount_account")} (données en dur)</span>
    <div className="tw-my-6">
      <span className="tw-block">{getLanguageVarValue("LANG_neobooking_bankaccount_account_validate")}</span>
      <div className="tw-overflow-x-auto">
        <div className="tw-overflow-hidden"></div>
        <table className="tw-w-full tw-text-left tw-text-sm">
          <thead className="tw-bg-gray-50">
            <tr>
              <th className="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider">{getLanguageVarValue("LANG_neobooking_bankaccount_label")}</th>
              <th className="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider">{getLanguageVarValue("LANG_neobooking_bankaccount_infos")}</th>
              <th className="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider">{getLanguageVarValue("LANG_neobooking_bankaccount_action")}</th>
            </tr>
          </thead>
          <tbody className="tw-bg-white">
            {
              bankAccount.map((b, i) => {
                return <tr key={`b_${i}`} className="hover:tw-bg-gray-50">
                  <td className="tw-px-6 tw-py-3 tw-whitespace-nowrap">
                    {
                      `${b.media_label} - n° ${b.ribAccountNumber}`
                    }
                  </td>
                  <td className="tw-px-6 tw-py-3 tw-whitespace-nowrap">
                    <Popup
                      btnElement={(onClick) => <Button onClick={onClick} size="sm" shape="link">{getLanguageVarValue("LANG_neobooking_bankaccount_details")}</Button>}
                      title={getLanguageVarValue("LANG_neobooking_bankaccount_details_account")}
                    >
                      <>
                        <div className="tw-overflow-x-auto">
                          <div className="tw-overflow-hidden"></div>
                          <table className="tw-w-full tw-text-left tw-text-sm ">
                            <tbody className="tw-bg-white tw-divide-y tw-divide-gray-200">
                              <tr className="hover:tw-bg-gray-50">
                                <td className="tw-py-4 tw-whitespace-nowrap">
                                  {getLanguageVarValue("LANG_neobooking_bankaccount_media_label")}
                                </td>
                                <td className="tw-py-4 tw-whitespace-nowrap">
                                  {b.media_label}
                                </td>
                              </tr>
                              <tr className="hover:tw-bg-gray-50">
                                <td className="tw-py-4 tw-whitespace-nowrap">
                                  {getLanguageVarValue("LANG_neobooking_bankaccount_validate")}
                                </td>
                                <td className="tw-py-4 tw-whitespace-nowrap">
                                  {b.validated ? "Oui" : "Non"}
                                </td>
                              </tr>
                              <tr className="hover:tw-bg-gray-50">
                                <td className="tw-py-4 tw-whitespace-nowrap">
                                  {getLanguageVarValue("LANG_neobooking_bankaccount_type")}
                                </td>
                                <td className="tw-py-4 tw-whitespace-nowrap">
                                  {b.type}
                                </td>
                              </tr>
                              {
                                b.type === "RIB" && <>
                                  <tr className="hover:tw-bg-gray-50">
                                    <td className="tw-py-4 tw-whitespace-nowrap">
                                      RIB: {getLanguageVarValue("LANG_neobooking_bankaccount_bank_code")}
                                    </td>
                                    <td className="tw-py-4 tw-whitespace-nowrap">
                                      {b.ribBankCode}
                                    </td>
                                  </tr>
                                  <tr className="hover:tw-bg-gray-50">
                                    <td className="tw-py-4 tw-whitespace-nowrap">
                                      RIB: {getLanguageVarValue("LANG_neobooking_bankaccount_agency_code")}
                                    </td>
                                    <td className="tw-py-4 tw-whitespace-nowrap">
                                      {b.ribBankAgency}
                                    </td>
                                  </tr>
                                  <tr className="hover:tw-bg-gray-50">
                                    <td className="tw-py-4 tw-whitespace-nowrap">
                                      RIB: {getLanguageVarValue("LANG_neobooking_bankaccount_account_number")}
                                    </td>
                                    <td className="tw-py-4 tw-whitespace-nowrap">
                                      {b.ribAccountNumber}
                                    </td>
                                  </tr>
                                  <tr className="hover:tw-bg-gray-50">
                                    <td className="tw-py-4 tw-whitespace-nowrap">
                                      {getLanguageVarValue("LANG_neobooking_bankaccount_key")}
                                    </td>
                                    <td className="tw-py-4 tw-whitespace-nowrap">
                                      {b.ribKey}
                                    </td>
                                  </tr>
                                </>
                              }
                              {
                                b.type === "IBAN" && <>
                                  <tr className="hover:tw-bg-gray-50">
                                    <td className="tw-py-4 tw-whitespace-nowrap">
                                      {getLanguageVarValue("LANG_neobooking_bankaccount_iban")}
                                    </td>
                                    <td className="tw-py-4 tw-whitespace-nowrap">
                                      {b.iban}
                                    </td>
                                  </tr>
                                  <tr className="hover:tw-bg-gray-50">
                                    <td className="tw-py-4 tw-whitespace-nowrap">
                                      {getLanguageVarValue("LANG_neobooking_bankaccount_bic")}
                                    </td>
                                    <td className="tw-py-4 tw-whitespace-nowrap">
                                      {b.bicCode}
                                    </td>
                                  </tr>
                                </>
                              }
                              <tr className="hover:tw-bg-gray-50">
                                <td className="tw-py-4 tw-whitespace-nowrap">
                                  {getLanguageVarValue("LANG_neobooking_bankaccount_address")}
                                </td>
                                <td className="tw-py-4 tw-whitespace-nowrap">
                                  {b.bankAddress}
                                </td>
                              </tr>
                              <tr className="hover:tw-bg-gray-50">
                                <td className="tw-py-4 tw-whitespace-nowrap">
                                  {getLanguageVarValue("LANG_neobooking_bankaccount_address_2")}
                                </td>
                                <td className="tw-py-4 tw-whitespace-nowrap">
                                  {b.bankAddress2}
                                </td>
                              </tr>
                              <tr className="hover:tw-bg-gray-50">
                                <td className="tw-py-4 tw-whitespace-nowrap">
                                  {getLanguageVarValue("LANG_neobooking_adr_zipcode")}
                                </td>
                                <td className="tw-py-4 tw-whitespace-nowrap">
                                  {b.postalCode}
                                </td>
                              </tr>
                              <tr className="hover:tw-bg-gray-50">
                                <td className="tw-py-4 tw-whitespace-nowrap">
                                  {getLanguageVarValue("LANG_neobooking_city")}
                                </td>
                                <td className="tw-py-4 tw-whitespace-nowrap">
                                  {b.city}
                                </td>
                              </tr>
                              <tr className="hover:tw-bg-gray-50">
                                <td className="tw-py-4 tw-whitespace-nowrap">
                                  {getLanguageVarValue("LANG_neobooking_country")}
                                </td>
                                <td className="tw-py-4 tw-whitespace-nowrap">
                                  {b.country}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </>
                    </Popup>
                  </td>
                  <td className="tw-px-6 tw-py-3 tw-whitespace-nowrap">
                    {
                      i === 0 ? <Button size="sm" shape="link">{getLanguageVarValue("LANG_neobooking_bankaccount_remove")}</Button> : getLanguageVarValue("LANG_neobooking_bankaccount_impossible_to_remove")
                    }
                  </td>
                </tr>
              })
            }
          </tbody>
        </table>
      </div>
    </div>
    <div className="tw-my-6">
      <span className="tw-block">{getLanguageVarValue("LANG_neobooking_bankaccount_save")}</span>
      <div className="tw-grid tw-grid-cols-2 tw-gap-2 tw-mb-4">
        <div className="tw-col-span-2 md:tw-col-span-1">
          <InputLabel>{getLanguageVarValue("LANG_neobooking_bankaccount_type")}</InputLabel>
          <Select options={bankType} additionalClassname="tw-w-full" onChange={(e) => setSelectedType(e.target.value)} />
        </div>
        <div className="tw-col-span-2 md:tw-col-span-1">
          <InputLabel>{getLanguageVarValue("LANG_neobooking_bankaccount_address")}</InputLabel>
          <InputText additionalClassname="tw-w-full" />
        </div>
        <div className="tw-col-span-2 md:tw-col-span-1">
          <InputLabel>{getLanguageVarValue("LANG_neobooking_bankaccount_media_label")}</InputLabel>
          <InputText additionalClassname="tw-w-full" />
        </div>
        {
          selectedType.toUpperCase() === "RIB" ?
            <>
              <div className="tw-col-span-2 md:tw-col-span-1">
                <InputLabel>{getLanguageVarValue("LANG_neobooking_bankaccount_bank_code")}</InputLabel>
                <InputText additionalClassname="tw-w-full" />
              </div>
              <div className="tw-col-span-2 md:tw-col-span-1">
                <InputLabel>{getLanguageVarValue("LANG_neobooking_bankaccount_agency_code")}</InputLabel>
                <InputText additionalClassname="tw-w-full" />
              </div>
              <div className="tw-col-span-2 md:tw-col-span-1">
                <InputLabel>{getLanguageVarValue("LANG_neobooking_bankaccount_account_number")}</InputLabel>
                <InputText additionalClassname="tw-w-full" />
              </div>
              <div className="tw-col-span-2 md:tw-col-span-1">
                <InputLabel>{getLanguageVarValue("LANG_neobooking_bankaccount_key")}</InputLabel>
                <InputText additionalClassname="tw-w-full" />
              </div>
            </>
            :
            <>
              <div className="tw-col-span-2 md:tw-col-span-1">
                <InputLabel>{getLanguageVarValue("LANG_neobooking_bankaccount_iban")}</InputLabel>
                <InputText additionalClassname="tw-w-full" />
              </div>
              <div className="tw-col-span-2 md:tw-col-span-1">
                <InputLabel>{getLanguageVarValue("LANG_neobooking_bankaccount_bic")}</InputLabel>
                <InputText additionalClassname="tw-w-full" />
              </div>
            </>
        }

        <div className="tw-col-span-2 md:tw-col-span-1">
          <InputLabel>{getLanguageVarValue("LANG_neobooking_city")}</InputLabel>
          <InputText additionalClassname="tw-w-full" />
        </div>
        <div className="tw-col-span-2 md:tw-col-span-1">
          <InputLabel>{getLanguageVarValue("LANG_neobooking_adr_zipcode")}</InputLabel>
          <InputText additionalClassname="tw-w-full" />
        </div>
        <div className="tw-col-span-2 md:tw-col-span-1">
          <InputLabel>{getLanguageVarValue("LANG_neobooking_country")}</InputLabel>
          <div className="tw-flex tw-gap-x-2">
            <InputText readOnly disabled value={selectedCountry} additionalClassname="tw-w-1/3" />
            <SelectCountry
              value={selectedCountry}
              onChange={(e) => setSelectedCountry(e.target.value)}
              additionalClassname="tw-w-2/3"
            />
          </div>
        </div>
      </div>
      <div>
        <Button>{getLanguageVarValue("LANG_neobooking_bankaccount_save")}</Button>
      </div>
    </div>
  </div>;
};

BankAccountsArea.propTypes = {
  //
};

export default BankAccountsArea;
